import { useEffect, useState } from 'react';

import BannerCTA from 'components/BannerCTA';
import BookingCTA from 'components/BookingCTA';
// import Popup from 'components/Popup';

import { isTouchDevice, isDesktop, isClient } from 'utils/helpers';

import AboutSection from './AboutSection';
import FoodAndDrink from './FoodAndDrink';
import FoodAndDrinkDesktop from './FoodAndDrinkDesktop';
import WhatsOn from './WhatsOn';
import Hero from './Hero';
import Location from './Location';
import Pricing from './Pricing';
import Description from './Description';

const LandingPage = ({ page }) => {
  const [isDesktopDevice, setIsDesktopDevice] = useState(false);

  useEffect(() => {
    if (isClient()) {
      setIsDesktopDevice(!isTouchDevice() && isDesktop('medium'));
    }
  }, []);

  return (
    <>
      {page.bannerCta && <BannerCTA {...page.bannerCta} />}

      <Hero page={page} key={page.id} />

      <div className="bg-dark-green">
        <Description
          descriptionOne={page.descriptionOne}
          descriptionTwo={page.descriptionTwo}
        />
      </div>

      <AboutSection title={page.aboutTitle} sections={page.aboutItems} />

      {page.priceItems.length ? (
        <Pricing
          title={page.pricesTitle}
          description={page.pricesDescription}
          prices={page.priceItems}
          image={page.pricesImage}
        />
      ) : null}

      {page.imageSlider.length ? (
        <WhatsOn
          description={page.groupsDescription}
          images={page.imageSlider}
        />
      ) : null}

      {isDesktopDevice ? (
        <FoodAndDrinkDesktop
          title={page.foodAndDrink}
          images={page.foodAndDrinkImages}
        />
      ) : (
        <FoodAndDrink
          title={page.foodAndDrink}
          images={page.foodAndDrinkImages}
        />
      )}

      {page.locationDetails && (
        <Location
          title={page.locationTitle}
          locationDetails={page.locationDetails}
        />
      )}

      <BookingCTA />

      {/* <Popup type="competition" /> */}
    </>
  );
};

export default LandingPage;
